import getPermissionsApi from '@/api/get/config/get-permissions';
import createUserRolePost from '@/api/post/user-role/create-user-role';
import Alert from '@/components/alert/alert-component';
import SubmitCard from '@/components/card/submit-card-component';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import { useMutation, useQuery } from '@/hooks/use-api';
import { useNavigate } from 'react-router-dom';
import Styled from './user-role-style';
import UserRolesForm from './user-roles-form';

/**
 * create new user
 * @returns {JSX.Element}
 */
const UserRolesNew = () => {
  const navigate = useNavigate();
  const [createUserRole, { loading: createUserRoleLoading }] =
    useMutation(createUserRolePost);
  const { data: permissions, loading } = useQuery(getPermissionsApi);

  return (
    <Styled.Main>
      <FormWrapper
        defaultValues={{}}
        onSubmit={(values) => {
          const submitValues = { ...values };
          const perm = submitValues.permissions;
          const subPermissions = [];
          Object.keys(perm).forEach((key) => {
            delete perm[key].all;
            subPermissions.push({
              feature_id: key,
              ...perm[key],
            });
          });
          submitValues.permissions = subPermissions;
          createUserRole(submitValues).then(() => {
            navigate('/app/user-management/user-roles');
            Alert({
              icon: 'success',
              text: 'User role created successfully',
            });
          });
        }}
      >
        <UserRolesForm
          type="create"
          permissions={permissions}
          isLoading={loading}
        />
        <SubmitCard
          padding="0"
          primaryButtonTitle="Save"
          primaryButtonType="submit"
          primaryButtonDisabled={false}
          primaryButtonWidth="112px"
          secondaryButtonType="button"
          secondaryButtonDisabled={false}
          secondaryButtonWidth="112px"
          isLoading={createUserRoleLoading || loading}
          submitClick={() => {}}
          submitClickSecondary={() => {
            navigate(-1);
          }}
          secondaryButtonTitle="Cancel"
        />
      </FormWrapper>
    </Styled.Main>
  );
};

UserRolesNew.propTypes = {};

export default UserRolesNew;
